<template>
  <div class="content-card processing-data terms-and-notes">
    <div>
      <slot name="headline"></slot>
      <div class="inline-text contract-terms" ref="processingInfoDivPrepared">
        <span class="docM" v-html="contractTerms"></span>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'DataProcessingInfo',
  data () {
    return {
      infoText: ''
    }
  },
  props: {
    consents: {
      type: Array
    }
  },
  methods: {
    addClickHandlerForModals (terms, t) {
      t = t.replaceAll('<a class="contract_data_info_modal">', '<a href="javascript:;" onclick="window.simonSummaryShowModal(\'' + terms + '\', \'contract_data_info_modal\')">')
      t = t.replaceAll('<a class="company_info_modal">', '<a href="javascript:;" onclick="window.simonSummaryShowModal(\'' + terms + '\', \'company_info_modal\')">')
      t = t.replaceAll('<a class="usage_data_modal">', '<a href="javascript:;" onclick="window.simonSummaryShowModal(\'' + terms + '\', \'usage_data_modal\')">')
      t = t.replaceAll('<a class="product_info_modal">', '<a href="javascript:;" onclick="window.simonSummaryShowModal(\'' + terms + '\', \'product_info_modal\')">')
      t = t.replaceAll('<a class="contract_info_modal">', '<a href="javascript:;" onclick="window.simonSummaryShowModal(\'' + terms + '\', \'contract_info_modal\')">')
      t = t.replaceAll('<a class="datatraffic_info_modal">', '<a href="javascript:;" onclick="window.simonSummaryShowModal(\'' + terms + '\', \'datatraffic_info_modal\')">')
      t = t.replaceAll(/"http:\/\/[^/]+\//g, '"/')
      t = t.replaceAll(/"https:\/\/[^/]+\//g, '"/')
      t = t.replaceAll(/"\/\/[^/]+\//g, '"/')
      t = t.replaceAll('<p> </p>', '')
      t = t.replaceAll('"/datenschutz"', '"/datenschutz" target="_blank"')
      return t
    }
  },
  computed: {
    consents_: function () {
      return Array.isArray(this.consents) ? this.consents : []
    },
    contractTerms: function () {
      const t = this.consents_.find(item => item.name === 'contract_terms')?.text || ''
      return this.addClickHandlerForModals('contract_terms', t)
    }
  }
}
</script>
